import React, { useState } from 'react';
import BigNumber from 'bignumber.js';
import Button from '@amzn/meridian/button';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import { calculateAllocationPercent } from '../../../services/utils';

const AB_EDIT_HEADER = 'Edit A/B Test';

export const AbNodeEditor = ({ nodeData, onAccept, onCancel }) => {
  const numberOfBuckets = nodeData.parameters.buckets;

  const buildAllocationAry = () => {
    const allocationAry = [];
    for (const [index, allocation] of nodeData.parameters.allocations.entries()) {
      allocationAry[index] = calculateAllocationPercent(allocation, numberOfBuckets);
    }
    return allocationAry;
  };

  const updateBounds = (e, allocationIndex) => {
    const newAry = [];
    for (const [index, allocation] of allocationData.entries()) {
      if (index === allocationIndex) {
        newAry[index] = parseFloat(e.target.value);
      } else {
        newAry[index] = allocation;
      }
    }
    setAllocationData(newAry);
  };

  const [allocationData, setAllocationData] = useState(buildAllocationAry());
  let sum = new BigNumber(0.0);

  return (
    <Modal open title={AB_EDIT_HEADER} width="400px">
      <div>
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Alloted percent</th>
            </tr>
          </thead>
          <tbody>
            {nodeData.parameters.allocations.map((allocation, allocationIndex) => {
              if (!isNaN(allocationData[allocationIndex])) {
                // don't add NaN due to an empty field while typing
                sum = sum.plus(allocationData[allocationIndex]);
              }
              return (
                <tr key={allocationIndex}>
                  <td>{allocation.name}</td>
                  <td>
                    <input
                      type="number"
                      min="0"
                      max="100"
                      step="0.01"
                      value={allocationData[allocationIndex]}
                      onChange={e => updateBounds(e, allocationIndex)}
                      className="form-control"
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <td className="text-muted">
                <em>Total Allocated</em>
              </td>
              <td className={sum.eq(100) ? 'text-success' : 'text-danger'}>
                <em>{sum.toNumber()}%</em>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <ModalFooter>
        <Row alignmentHorizontal="right" widths="fit">
          <Button type="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="primary" disabled={!sum.eq(100)} onClick={() => onAccept(allocationData)}>
            Accept
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};
